/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Route, Routes } from "react-router-dom";
import IFrameConnector from "./components/iframe-connector";
import { TrelloPowerUpProvider } from "../external/trello-pu__core/trello-iframe/context";
import Authorize from "../external/trello-pu__core/components/authorize";
import Modal from "./components/modal";
import React, { useEffect } from "react";
import CardButton from "./components/card-button";
import AttachmentSection from "./components/attachment-section";

export function App() {
  useEffect(() => {
    registerTrelloCardElement();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<div>Links Trello Power-Up</div>} />
      {/* <Route path="/iframeconnector" element={<div>iframe connector</div>} /> */}
      <Route path="/iframeconnector" element={<IFrameConnector />} />
      <Route path="/modal" element={withTrelloPowerUpProvider(<Modal />)} />
      <Route
        path="/authorize"
        element={withTrelloPowerUpProvider(
          <Authorize appName={process.env.APP_NAME as string} />
        )}
      />
      <Route
        path="/card-button"
        element={withTrelloPowerUpProvider(<CardButton />)}
      />
      <Route
        path="/attachment-section"
        element={withTrelloPowerUpProvider(<AttachmentSection />)}
      />
      {/* <Route
        path="/attachment-section"
        element={withTrelloPowerUpProvider(<Authorize />)}
      /> */}
    </Routes>
  );
}

const withTrelloPowerUpProvider = (Component: React.ReactNode) => (
  <TrelloPowerUpProvider
  // appKey={process.env.API_KEY as string}
  // appName={process.env.APP_NAME as string}
  >
    {Component}
  </TrelloPowerUpProvider>
);

function registerTrelloCardElement() {
  const scriptSrc = window.customElements
    ? "/card.min.js"
    : "/card-polyfilled.min.js";
  // @ts-ignore
  window.cardComponentLoaded = new Promise(function (resolve) {
    const cardJs = document.createElement("script");
    cardJs.crossOrigin = "anonymous";
    cardJs.src = "https://p.trellocdn.com" + scriptSrc;
    cardJs.onload = resolve;
    document.head.appendChild(cardJs);
  });
}
